<template>
  <div>
    <TopBar :mode="props.mode" @toggle="emit('toggle')">
      <span class="text-[21px] font-semibold custom:text-lg xl:hidden">
        Dashboard</span
      >
    </TopBar>
    <div class="p-4">
      <div class="mb-4 hidden xl:flex">
        <span class="text-[21px] font-semibold custom:text-lg">Dashboard</span>
      </div>
      <div v-if="isTrialUser && false" class="mb-4">
        <div class="p-4 rounded-lg flex items-center gap-4 bg-warning-100">
          <span
            class="w-[36px] h-[36px] text-warning-100 bg-white-100 flex items-center justify-center rounded-full"
          >
            <OctagonAlert :size="24" :stroke-width="1.75" />
          </span>
          <h6 v-if="timeLeft" class="text-black-100">
            FREE TRIAL - You have
            <span class="font-medium">{{ 10 - getReports }}</span>
            Pages Left - Automate SEO, Save ~99%, Rank higher - Unlock Full
            access (click
            <RouterLink
              :to="{
                name: 'account-subscription',
                query: { coupon: 'q58nJfJO' },
              }"
              class="border-b-2 border-black-100"
              >here</RouterLink
            >
            for 20% off, limited time)
            {{ timeLeft }}
          </h6>
          <h6 v-else class="text-black-100">
            FREE TRIAL - You have
            <span class="font-medium">{{ 10 - getReports }}</span>
            Pages Left - Automate SEO, Save ~99%, Rank higher -
            <RouterLink
              :to="{ name: 'account-subscription' }"
              class="border-b-2 border-black-100"
              >Unlock Full access</RouterLink
            >
          </h6>
        </div>
      </div>
      <div class="mb-4">
        <div class="p-4 rounded-lg flex items-center gap-4 bg-info-100">
          <span
            class="w-[36px] h-[36px] text-info-100 bg-white-100 flex items-center justify-center rounded-full"
          >
            <Info :size="24" :stroke-width="1.75" />
          </span>
          <div class="flex-1">
            <span class="text-white-100"
              >Our Free Credits Promotion is now complete! You now have your
              proper account credits updated to x5 or more! Make sure to check
              the EXPIRY DATE for your Keyword Discovery/Spy reports. If you
              have questions, or want to upgrade your credits and extend your
              data storage on our system, please check
              <a
                href="https://seocopilotai.com/seo-co-pilot-new-credits-announcement"
                target="_blank"
                class="underline"
                >here</a
              >
            </span>
          </div>
        </div>
      </div>
      <!-- Remove when the issue is resolved -->
      <div v-if="false" class="mb-6">
        <div class="p-4 rounded-lg flex items-center gap-4 bg-info-100">
          <span
            class="w-[36px] h-[36px] text-info-100 bg-white-100 flex items-center justify-center rounded-full"
          >
            <Info :size="24" :stroke-width="1.75" />
          </span>
          <div class="flex-1">
            <span class="text-white-100"
              >Value SERP seems to have addressed most of their earlier issues,
              and users can now get back to running reports in the system.
              However, Value SERP has noted that resources may still experience
              some intermittency. Be sure to check your reports to ensure they
              contain all the information you need—they should, based on current
              updates.</span
            >
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-6">
        <div
          class="grid grid-cols-3 gap-16 custom:grid-cols-2 custom:gap-3 sm:!grid-cols-1"
        >
          <template v-for="(widget, index) in widgets" :key="index">
            <div
              v-if="widget.show"
              class="pt-3 pb-4 flex items-center justify-between flex-col gap-2 transition-all duration-500 relative"
              :class="[
                mode === 'dark' ? 'bg-dark-70' : 'bg-white-100',
                index === 2 ? 'rounded-xl' : 'rounded-tl-xl rounded-bl-xl',
                currentStep === index && currentStep !== 3
                  ? mode === 'dark'
                    ? 'shadow-darkActiveCard'
                    : 'shadow-activeCard'
                  : 'shadow-card',
              ]"
            >
              <div class="text-center px-10">
                <h2 class="text-lg font-semibold 2xl:text-base">
                  {{ widget.title }}
                </h2>
              </div>
              <div
                class="relative text-center py-5 px-10 min-h-[136px] flex flex-col justify-center items-center"
                :class="[mode === 'dark' ? 'bg-dark-3' : 'bg-gray-20']"
              >
                <span
                  class="absolute -left-[18px] top-1/2 -translate-y-1/2 -rotate-90 transform text-[23px] uppercase font-bold"
                  :class="[mode === 'dark' ? 'text-dark-2' : 'text-white-100']"
                  >{{ index === 0 ? "Start" : `Step ${index + 1}` }}</span
                >
                <h6
                  class="px-4"
                  :class="[
                    mode === 'dark'
                      ? 'text-gray-100 text-opacity-70'
                      : 'text-black-100',
                  ]"
                >
                  <span v-html="widget.text"></span>
                </h6>
              </div>
              <div class="flex items-center justify-center gap-2 px-10 mt-2">
                <button
                  class="button secondary-button w-[230px] relative z-20"
                  @click="goToRouter(widget.to, index)"
                >
                  {{ widget.goto }}
                </button>
              </div>
              <div
                class="absolute inset-0 z-10 cursor-pointer"
                @click="goToRouter(widget.to, index)"
              ></div>
              <div
                v-if="index !== 2"
                class="absolute top-0 -right-10 w-10 overflow-hidden bottom-0"
              >
                <div
                  class="absolute top-1/2 transform -translate-y-1/2 left-0 w-0 h-0 border-solid dashboard-arrow"
                ></div>
              </div>
            </div>
          </template>
        </div>
        <RecentSearch
          :reports="reports"
          :KDreports="KDreports"
          :projects="projects"
          :mode="props.mode"
        />
        <div>
          <template
            v-if="topics && topics.results && topics.results.length > 0"
          >
            <div class="grid grid-cols-3 gap-6">
              <div
                class="flex flex-col rounded-xl shadow-card overflow-hidden"
                :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
              >
                <div
                  class="border-b px-4 py-3.5"
                  :class="
                    mode === 'dark' ? 'border-dark-50' : 'border-gray-100'
                  "
                >
                  <span class="font-semibold text-[17px] leading-none"
                    >Useful links</span
                  >
                </div>
                <div class="px-4 py-3">
                  <ul class="list-disc pl-4 grid gap-2">
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://calendly.com/joshbachynski/seocp-training-session"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >Live SEO Copilot Training</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.seocopilotai.com/tutorials"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >Video Tutorials</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://moz.com/blog/panda-41-google-leaked-dos-and-donts-whiteboard-friday"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >MOZ Whiteboard Friday</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.seroundtable.com/josh-bachynski-25801.html"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >SEO Community Honors - SE RoundTable</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="http://j.mp/joshtedx"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >TEDx Talk “The Future of Google, Search and Ethics”</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.youtube.com/@joshbachynski"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >SEO Copilot on YouTube</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.seocopilotai.com/seo-for-agencies"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >Built for Agencies</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.seocopilotai.com/power-of-precision-seo"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >Case Study</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.seocopilotai.com/how-to-use-ceepee"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >CeePee Help Guide</a
                      >
                    </li>
                    <li
                      :class="[
                        mode === 'dark'
                          ? 'text-gray-100 text-opacity-70'
                          : 'text-gray-700',
                      ]"
                    >
                      <a
                        href="https://www.seocopilotai.com/custom-knowledge-base"
                        target="_blank"
                        class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
                        :class="[
                          mode === 'dark'
                            ? 'text-gray-100 text-opacity-70'
                            : 'text-gray-700',
                        ]"
                        >Custom Knowledge Base Guidelines</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <template v-for="(topic, key) in topics.results" :key="key">
                <TopicWithArticles :topic="topic" :mode="mode" />
              </template>
            </div>
          </template>
        </div>
        <Users :mode="props.mode" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import type { Ref } from "vue";
import { useToast } from "vue-toast-notification";
import { useRouter } from "vue-router";
import axios from "axios";
import TopBar from "../components/TopBar.vue";
import Users from "../components/UsersComponent.vue";
import RecentSearch from "../components/RecentSearch.vue";
import TopicWithArticles from "../components/TopicWithArticles.vue";
import { tutorials, TUTORIAL } from "../libs/data/tutorials";
import { customOrder } from "../libs";
import { useUserStore } from "../stores/user";
import helper from "../libs/helper";
import ApiRequest from "../libs/ApiRequest";
import { SearchReport, KDList, SearchResult, KPlan } from "../libs/types";
import { getPlanners } from "../libs/Api";
import { Info, OctagonAlert } from "lucide-vue-next";
const userStore = useUserStore();
interface Props {
  mode: string;
}
const $toast = useToast();
const router = useRouter();
const emit = defineEmits(["toggle"]);
const props = defineProps<Props>();
const tutorialPage: Ref<number> = ref(1);
const tutorialPerPage: Ref<number> = ref(10);
const tutorialHasNext: Ref<boolean> = ref(false);
const currTuts: Ref<TUTORIAL[]> = ref([]);
const reports: Ref<SearchResult[] | null> = ref(null);
const KDreports: Ref<KPlan[] | null> = ref(null);
const projects: Ref<any[]> = ref([]);
const showContent = ref(true);
const activeWidget = ref({});
const interval = ref(null);
const timeLeft = ref("");
const widgets = ref([
  {
    id: 1,
    title: "Keyword Discovery - Find the Ranking Opportunities",
    text: "Our AI will scan thousands of keywords to find where your competitors are weak, and the traffic is high and ready to buy",
    goto: "Find Ranking Opportunities",
    to: "KeywordPlanner",
    label: "Next - Find Boosting Keywords",
    show: true,
  },
  {
    id: 2,
    title: "Keyword Spy - Find the Boosting OnPage Keywords",
    text: "Our advanced AI will build you BERT, RankBrain, TW-Bert and Vector Embedded AI models that uncover the boosting keywords",
    goto: "Find Boosting Keywords",
    to: "serp-keyword-spy",
    label: "Next - View Boosting Keywords",
    show: true,
  },
  {
    id: 4,
    title: "Article Builder - Build Your Perfect SEO Page",
    text: "Make High-Quality Human Level EEAT content that is factual and saves you ~99% on Costs and Time!",
    goto: "Use our AI On-Page SEO",
    to: "editor",
    label: "",
    show: true,
  },
]);
const topics = ref([]);
onMounted(async () => {
  activeWidget.value = widgets.value[0];
  if (userStore.user.tier && userStore.user.tier.toLowerCase() === "trial") {
    showContent.value = false;
    checkOfferStatus();
    interval.value = setInterval(updateTimer, 1000);
  }
  userStore.setIsLoading(true);
  getTutorials(1);
  await Promise.all([
    loadRecentSearch(),
    loadRecentKDSearch(),
    loadProjects(),
    getTopics(),
  ]);
  getCurrentUser();
  userStore.setIsLoading(false);
});
const isTrialUser = computed(() => {
  return userStore.user.tier && userStore.user.tier.toLowerCase() === "trial"
    ? true
    : false;
});
const getReports = computed(() => {
  return reports.value ? reports.value.length : 0;
});
const currentStep = computed(() => {
  return userStore.currentDashboardStep;
});
const offerEndDate = computed(() => {
  const date = new Date(userStore.user.subscribed_until);
  const newDate = new Date(date);
  newDate.setDate(date.getDate() - 9);
  return newDate.toISOString().slice(0, 19);
});
const getTutorials = (page: number) => {
  tutorialPage.value = page;
  tutorialHasNext.value =
    tutorials.length > tutorialPage.value * tutorialPerPage.value;
  currTuts.value = customOrder(tutorials, "id", "desc");
};
const loadRecentSearch = async () => {
  try {
    const { data } = await ApiRequest().get<SearchReport>(
      `/api/serp/search/get_list_dashboard?is_archive=false&limit=10`
    );
    const { results = [] } = data;
    reports.value = results;
  } catch (error) {
    const extractedError = helper.extractAlert(error);
    $toast.error(extractedError.alert.message);
  }
};
const loadRecentKDSearch = async () => {
  try {
    const response = await getPlanners(10, "", 1, "", "", "");
    if (response) {
      const data: KDList = response;
      const plans = customOrder(data.results, "created_at", "desc");
      KDreports.value = plans;
    }
  } catch (error) {
    const extractedError = helper.extractAlert(error);
    $toast.error("discovery" + extractedError.alert.message);
  }
};
const loadProjects = async () => {
  try {
    const { data } = await ApiRequest().get(`/api/serp/projects`);
    const { results = [] } = data;
    projects.value = helper.lodashOrder(results, "created_at", "desc");
    projects.value = projects.value.slice(0, 10);
  } catch (error) {
    const extractedError = helper.extractAlert(error);
    $toast.error(extractedError.alert.message);
    if (extractedError.redirect) {
      userStore.signOut();
      router.push({ name: extractedError.redirect });
    }
  }
};
const goToRouter = (to, index) => {
  userStore.setCurrentDashboardStep(index + 1);
  router.push({ name: to });
};
const getTopics = async () => {
  const url = `https://api.seocopilotai.com/api/v1/topics`;
  try {
    const response = await axios.get(url);
    topics.value = response.data;
  } catch (error) {
    $toast.error("Error fetching topics:", error.message);
  }
};
const checkOfferStatus = () => {
  const now = new Date();
  if (now >= new Date(offerEndDate.value)) {
    clearInterval(interval.value);
  }
};
const updateTimer = () => {
  const now = new Date();
  const newDate = new Date(offerEndDate.value);
  const timeDiff = newDate.getTime() - now.getTime();
  if (timeDiff > 0) {
    const seconds = Math.floor((timeDiff / 1000) % 60);
    const minutes = Math.floor((timeDiff / 1000 / 60) % 60);
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    timeLeft.value = `${days}d ${hours}h ${minutes}m ${seconds}s`;
  } else {
    timeLeft.value = "";
  }
};
const getCurrentUser = async () => {
  try {
    const URL = `/api/auth/current-user`;
    const res = await ApiRequest().get(URL);
    if (res.status !== 200) {
      throw new Error("Something went wrong!");
    }
    userStore.setUser(res.data);
  } catch (error) {
    const extractedError = helper.extractAlert(error, "app");
    $toast.error(extractedError.alert.message);
  }
};
</script>
